import { createSelector } from 'reselect'

const select = (state) => state.footprints

const selectFootprints = createSelector(select, (footprints) => footprints)

const selectIsFetching = createSelector(
  select,
  (footprints) => footprints.isFetching
)

const selectSearchActive = createSelector(
  select,
  (footprints) => footprints.searchActive
)

const selectError = createSelector(select, (footprints) => footprints.error)

const selectId = createSelector(select, (footprints) => footprints.id)

const selectFormFields = createSelector(select, (footprints) => footprints.form)

export {
  selectFootprints,
  selectIsFetching,
  selectSearchActive,
  selectError,
  selectId,
  selectFormFields
}
